import { TemplateValueError } from "./TemplateValueError.js";

/**
 * Finds the given template variable errors.
 */
export const findVariableErrors = (name: string, values: TemplateValueError[]) => {
  return values.filter((value) => value.name === name).flatMap((error) => error.messages);
};
